module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Suset1-44641b4133a0ee9e83c81e261c328d7b.svg";